


















































import BaseLoading from '@/components/base/BaseLoading.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import BaseTable from '@/components/BaseTable.vue';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import { ModuleResponseDTO } from '@/jbi-shared/dto/jtms.dtos';
import { ModuleSortColumns } from '@/jbi-shared/types/jtms.types';
import { SortOrder } from '@/store/types/general.types';
import { mixins } from 'vue-class-component';
import { Component, Emit, Prop } from 'vue-property-decorator';
import { moduleSortableHeaders } from '@/store/modules/jtms/module/module.const';
import ModuleRow from './ModuleRow.vue';

@Component({
  components: {
    BaseTable,
    BasePagination,
    BaseLoading,
    SortableTableHeader,
    ModuleRow
  }
})
export default class ModuleList extends mixins(PaginationMixin) {
  @Prop() items!: ModuleResponseDTO[];
  @Prop(Number) currentPage!: number;
  @Prop(Number) totalNumberOfPage!: number;
  @Prop(Number) totalCount!: number;
  @Prop(Boolean) isFirstPage!: boolean;
  @Prop(Boolean) isLastPage!: boolean;
  @Prop(Number) startItemIndex!: number;
  @Prop(Number) endItemIndex!: number;
  @Prop(String) sortColumn!: ModuleSortColumns;
  @Prop(String) sortOrder!: SortOrder;

  moduleRowKey: number = Math.floor(Math.random() * 999);

  get modules() {
    return this.items || [];
  }

  get sortableHeaders() {
    return moduleSortableHeaders;
  }

  get sortColumnEnum() {
    return ModuleSortColumns;
  }

  get isPaginated() {
    return typeof this.totalNumberOfPage === 'number';
  }

  onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder:
          this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC
      });
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: SortOrder.DESC
    });
    this.moduleRowKey += 1;
  }

  getSortOrderOfColumn(name: string) {
    if (this.sortColumn === name) {
      return this.sortOrder;
    }
    return SortOrder.ASC;
  }

  @Emit('archive-module')
  archiveModule(moduleToArchive: ModuleResponseDTO) {
    return moduleToArchive;
  }

  @Emit('activate-module')
  activateModule(moduleToActivate: ModuleResponseDTO) {
    return moduleToActivate;
  }
}
